import React from 'react';
import { motion } from 'framer-motion';
import { Home, Trash2, Truck, BoxIcon } from 'lucide-react';
const services = [{
  title: 'Residential Moving',
  description: 'Full-service moving for homes and apartments of all sizes. We pack, load, transport, and unload with care.',
  icon: Home
}, {
  title: 'Specialty Item Moving',
  description: 'Got a pool table, piano, or heavy appliance? We specialize in moving oversized and delicate items with extra care.',
  icon: Truck
}, {
  title: 'Storage Cleanout',
  description: 'Need to empty a storage unit? We can move items to your new home or dispose of them for you.',
  icon: BoxIcon
}, {
  title: 'Junk Removal',
  description: 'Decluttering before a move? We haul away unwanted furniture, appliances, and general debris responsibly.',
  icon: Trash2
}];
export function Services() {
  return <section className="py-24 bg-gray-50" id="services" data-id="element-111">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-112">
        <div className="text-center mb-16" data-id="element-113">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-114">
            Our Services
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full mb-6" data-id="element-115"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-116">
            Comprehensive moving and clearing solutions tailored to your needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-117">
          {services.map((service, index) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-118">
              <div className="w-14 h-14 bg-navy/5 rounded-lg flex items-center justify-center mb-6" data-id="element-119">
                <service.icon className="h-8 w-8 text-navy" data-id="element-120" />
              </div>
              <h3 className="text-xl font-bold text-navy mb-3" data-id="element-121">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-122">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}